<template>
  <div class="CoalModel_box">
    <div v-if="!isDetail">
      <!-- 搜索 -->
      <div class="CoalModel_box_title">
        <div class="CoalModel_box_title_desc">司机管理</div>
      </div>
      <el-divider></el-divider>
      <el-form
        :inline="true"
        :model="filterForm"
        class="demo-form-inline"
        ref="form"
        size="small"
      >
        <el-form-item label>
          <el-input
            placeholder="请输入司机姓名"
            v-model="filterForm.driverName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            placeholder="请输入手机号"
            v-model="filterForm.driverPhone"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            placeholder="请输入身份证号"
            v-model="filterForm.idCard"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            placeholder="请输入绑定车牌号"
            v-model="filterForm.carLicensePlateNo"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select
            v-model="filterForm.status"
            placeholder="状态"
            filterable
            clearable
          >
            <el-option
              v-for="item in stateList"
              :key="item.code"
              :value="item.code"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="handleSearch"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="getReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
      <!-- 司机管理列表 -->
      <el-table
        v-loading="loading"
        :data="driverList"
        stripe
        size="mini"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          align="center"
          width="80"
          fixed
          label="序号"
        ></el-table-column>
        <el-table-column prop="driverName" label="姓名"></el-table-column>
        <el-table-column prop="driverPhone" label="手机号"></el-table-column>
        <el-table-column prop="idCard" label="身份证号"></el-table-column>
        <el-table-column
          prop="carLicensePlateNo"
          label="绑定车辆"
        ></el-table-column>
        <el-table-column prop="statusName" label="状态"></el-table-column>
        <el-table-column fixed="right" label="操作" width="360">
          <template slot-scope="scope">
            <kt-button
              label="审核"
              icon="fa fa-edit"
              perms="30400"
              @click="checkComponent(scope.row, true)"
              type="primary"
              v-if="scope.row.status === 1"
            />
            <!-- <kt-button
              label="启用"
              icon="fa fa-check"
              perms="30401"
              @click="getEnable(scope.row)"
              v-if="scope.row.status === 4"
              type="primary"
            />
            <kt-button
              label="停用"
              icon="fa fa-remove"
              perms="30401"
              type="danger"
              @click="getOutService(scope.row)"
              v-if="scope.row.status === 2"
            /> -->
            <kt-button
              label="查看"
              perms="-1"
              icon="fa fa-edit"
              v-if="scope.row.status !== 1"
              @click="checkComponent(scope.row, false)"
            />
            <kt-button
              label="修改手机号"
              icon="fa fa-edit"
              perms="60525"
              @click="updateDriverPhone(scope.row, true)"
              type="primary"
              v-if="scope.row.status==2"
            />
            <kt-button
              label="修改司机信息"
              icon="fa fa-edit"
              perms="30951"
              @click="getRevise(scope.row)"
              type="primary"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        ></el-pagination>
      </div>
    </div>
    <!--查看详情-->
    <DriverDetail
      v-if="isDetail"
      :driverNo="driverNo"
      :isShow="isShow"
      @detailFun="detailFun"
    />
    <el-dialog
      :visible.sync="isShowUpdatePhone"
      v-if="isShowUpdatePhone"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="修改手机号"
      @close="handleCancel"
    >
      <el-form :model="updateForm" size="small" label-width="100">
        <el-form-item label="司机姓名：">
          <span>{{currentRow.driverName}}</span>
        </el-form-item>
        <el-form-item label="当前手机号：">
          <span>{{currentRow.driverPhone}}</span>
        </el-form-item>
        <el-form-item label="新手机号：" prop="driverPhone">
          <el-input  style="width:200px" v-model.number="updateForm.driverPhone" placeholder="请输入新手机号" maxlength="11" clearable></el-input>
          <span :class="captureTxt=='获取验证码'||captureTxt =='重新发送' ? 'get-capture' :'disabled get-capture'"  @click="handleGetCapture">{{captureTxt}}</span>
        </el-form-item>
        <el-form-item label="新手机号验证码：" prop="capture">
          <el-input  style="width:200px" v-model="updateForm.capture" placeholder="请输入验证码" maxlength="6" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirmInfo">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="司机信息修改" :visible.sync="dialogFormVisible" :before-close="resetForm">
      <el-form :model="reviseData" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" size="mini">
        <el-form-item label="姓名" prop="driverName">
          <el-input v-model="reviseData.driverName" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="身份证件" prop="idCard">
          <el-input v-model="reviseData.idCard" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="driverPhone">
          <el-input v-model="reviseData.driverPhone" style="width: 200px" disabled></el-input>
        </el-form-item>
        <el-form-item label="身份证正反面" prop="idCardImg">
          <div class="list">
            <div class="list_right">
              <UploadImg
                :imageUrl='reviseData.idCardFrontImg'
                ref='idCardFrontImg'
                name='身份证正面'
                domKeys="idCardFrontImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('idCardFrontImg')">点击上传</el-button>
            </div>
            <div class="list_right">
              <UploadImg
                :imageUrl='reviseData.idCardBackImg'
                ref='idCardBackImg'
                name='身份证反面'
                domKeys="idCardBackImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('idCardBackImg')">点击上传</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="驾驶证正反面" prop="drivingLicense">
          <div class="list">
            <div class="list_right">
              <UploadImg
                :imageUrl='reviseData.driveLicenceFrontImg'
                ref='driveLicenceFrontImg'
                name='驾驶证正面'
                domKeys="driveLicenceFrontImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('driveLicenceFrontImg')">点击上传</el-button>
            </div>
            <div class="list_right">
              <UploadImg
                :imageUrl='reviseData.driveLicenceBackImg'
                ref='driveLicenceBackImg'
                name='驾驶证反面'
                domKeys="driveLicenceBackImg"
                @setImgUrl="handleChangeImg"
                @setDomKeys="submitUpload"
              />
              <el-button style="margin-top: 10px" type="info" @click="submitUpload('driveLicenceBackImg')">点击上传</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" style="margin-right: 20px" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";
import DriverDetail from "./DriverDetail";
import UploadImg from '@/components/Core/UploadImg'
import { hasPermission } from '@/permission/index.js'
let timer = null
export default {
  components: {
    KtButton,
    DriverDetail,
    UploadImg
  },
  data() {
    return {
      isShow: false,
      driverNo: "",
      size: "small",
      loading: false,
      filterForm: {
        driverName: "",
        driverPhone: "",
        idCard: "",
        carLicensePlateNo: "",
        status: "",
      },
      stateList: [
        {
          code: "0",
          name: "已注册",
        },
        {
          code: "1",
          name: "待审核",
        },
        {
          code: "2",
          name: "已启用",
        },
        {
          code: "3",
          name: "审核驳回",
        },
      ],
      driverList: [],
      isDetail: false,
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      dialogFormVisible: false, //修改弹窗
      reviseData: {},
      isShowUpdatePhone: false,
      updateForm:{},
      captureTxt:'获取验证码',
      rules:{
        driverName: [ { required: true, message: "请输入员工姓名", trigger: "blur" }],
        driverPhone: [ { required: true, message: "请输入员工手机号", trigger: "blur" },
          { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' },
          {
            pattern: /^1[3456789]{1}[0-9]{9}$/,
            message: '请输入正确的手机号码'
          }
        ],
        idCard: [ { required: true, message: "请输入员工身份证", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '证件号码格式有误！',
            trigger: ['blur','change']
          }
        ],
        idCardImg:[
          {required:true ,  validator:(rule,value,callback) => {
            if(this.reviseData.idCardBackImg && this.reviseData.idCardFrontImg){
              return callback()
            }else{
              return callback(new Error('请上传身份证正反面'))
            }
          },trigger:['change', 'blur']}
        ],
        drivingLicense:[
          {required:true ,  validator:(rule,value,callback) => {
            if(this.reviseData.driveLicenceFrontImg && this.reviseData.driveLicenceBackImg){
              return callback()
            }else{
              return callback(new Error('请上传驾驶证正反面'))
            }
          },trigger:['change', 'blur']}
        ]
      },
    };
  },
  mounted() {
    this.getDriverList();
    this.$once('hook:beforeDestroy',() => {
      timer&&  clearTimeout(timer)
    })
  },
  methods: {
    // 获取司机列表
    async getDriverList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };

      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        params["searchFieldList[" + index + "].fieldName"] = key;
        params["searchFieldList[" + index + "].singleValue"] = val;
        index++;
      }
      let res = await this.$api.DriverModel.driverList(params);

      this.driverList = !res.data.dtoList ? [] : res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },

    // 重置
    getReset() {
      this.filterForm = {
        driverName: "",
        driverPhone: "",
        idCard: "",
        carLicensePlateNo: "",
        status: "",
      };

      this.pageNo = 1;
      this.getDriverList();
    },

    // 启用
    async getEnable(row) {
      let confirm = await this.$confirm("是否启用该司机?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((error) => {
        this.$message({
          message: "已取消操作",
          type: "warning",
        });
      });

      if (!confirm) return;
      await this.$api.DriverModel.driverEnable({
        driverNo: row.driverNo,
      });

      this.$message({
        message: "启用成功!",
        type: "success",
      });

      this.getDriverList();
    },
    // 停用
    async getOutService(row) {
      let confirm = await this.$confirm("是否停用该司机?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((error) => {
        this.$message({
          message: "已取消操作",
          type: "warning",
        });
      });

      if (!confirm) return;
      await this.$api.DriverModel.driverEnable({
        driverNo: row.driverNo,
      });

      this.$message({
        message: "停用成功!",
        type: "success",
      });

      this.getDriverList();
    },

    //查看司机详情
    checkComponent(val, flag) {
      this.driverNo = val.driverNo;
      this.isShow = flag;
      this.isDetail = true;
    },

    detailFun(val) {
      this.isDetail = val;
      this.getDriverList();
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getDriverList();
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getDriverList();
    },
    updateDriverPhone(row) {
      this.currentRow = row;
      this.isShowUpdatePhone = true;
    },
    async handleConfirmInfo(){
      if(!this.updateForm.driverPhone){
        this.$message({
          type: 'error',
          message:'请先输入手机号',
          offset:300
        })
        return
      }
      if(!this.updateForm.capture){
        this.$message({
          type: 'error',
          message:'请输入验证码',
          offset:300
        })
        return
      }
      let res = await this.$api.DriverModel.updatePhone({
        oldPhone: this.currentRow.driverPhone,
        phone: this.updateForm.driverPhone ,
        smsCode: this.updateForm.capture
      })
      this.$message({
        type:'success',
        message:'修改成功',
        offset: 300
      })
      this.isShowUpdatePhone = false
      this.updateForm ={}
      timer && clearTimeout(timer)
      this.captureTxt = '获取验证码'
      this.getDriverList()
    },
    handleCancel(){
      this.isShowUpdatePhone = false
      timer && clearTimeout(timer)
      this.captureTxt = '获取验证码'
      this.updateForm ={}
    },
    async handleGetCapture(){
      if(!this.updateForm.driverPhone){
        this.$message({
          type: 'error',
          message:'请先输入手机号',
          offset:300
        })
        return
      }
      if(!/^\d{11}$/.test(this.updateForm.driverPhone)){
        this.$message({
          type: 'error',
          message:'请输入正确手机号',
          offset:300
        })
        return
      }
      if(this.captureTxt.includes('s')) return
      let res = await this.$api.DriverModel.getSmsCode({
        phone: this.updateForm.driverPhone
      })
      this.countDown(60)
    },
    countDown(countDown){
      timer = setTimeout(() => {
        if(countDown<=0){
          this.captureTxt = '重新发送'
          clearTimeout(timer)
        }else{
          this.captureTxt = countDown +'s'
          this.countDown(--countDown)
        }
      }, 1000);
    },
    async getRevise(row){
      this.dialogFormVisible = true
      const _t = this;
      const newObj = { driverNo: row.driverNo };
      const data = await _t.$api.DriverModel.driverGet(newObj)
      if (data.code === "0") {
        this.reviseData = data.data
      } else {
        _t.$message({
          message: "查询失败, " + data.message,
          type: "error",
        });
      }

    },
    // 修改保存
    submitForm(formName){
      this.$refs[formName].validate( async(valid) => {
        if (valid) {
          const params = {
            driverNo: this.reviseData.driverNo,
            driverName: this.reviseData.driverName,
            driverPhone: this.reviseData.driverPhone,
            idCard: this.reviseData.idCard,
            idCardBackImg: this.reviseData.idCardBackImg,
            idCardFrontImg: this.reviseData.idCardFrontImg,
            driveLicenceFrontImg: this.reviseData.driveLicenceFrontImg,
            driveLicenceBackImg: this.reviseData.driveLicenceBackImg
          }
          const req = await this.$api.DriverModel.updateDriverInfo(params)
          if(req.code === '0'){
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.getDriverList();
            this.resetForm('ruleForm')
          }else{
            this.$message({
              message: req.message,
              type: 'error'
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitUpload(ref){
      console.log(ref)
      this.domKeys = ref
      this.$refs[ref].submitUpload()
    },
    resetForm(formName) {
      if(formName === 'ruleForm'){
        this.$refs[formName].resetFields();
      }
      this.dialogFormVisible = false
      this.reviseData = {}
    },
    handleChangeImg(res){
      console.log(res)
      this.reviseData[this.domKeys] = res
    },
  },
};
</script>
<style lang="scss">
.CoalModel_box {
  box-sizing: border-box;
  padding: 10px;
  .CoalModel_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalModel_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalModel_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .CoalModel_box_dialog {
    display: flex;
    justify-content: space-around;

    .CoalModel_box_dialog_nr {
      width: 33%;

      div:first-child {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }

  .CoalModel_box_dialog_nr_ts {
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
    font-size: 16px;
  }
}
.get-capture{
  width: 100px;
  text-align: center;
  margin-left: 10px;
  // text-decoration: underline;
  cursor: pointer;
  color: #007fff;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
}
.disabled{
  color: #ccc;
}、
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.list{
  display: flex;
}
.list_right{
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.uploader{
  display: flex;
  width: 178px;
  height: 178px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  div{
    margin-top: 10px;
    font-size: 12px;
  }
}
</style>
